const packageDetails = require("../../package.json");
const { name, version } = packageDetails;

export { name, version };
